import { FC, useCallback, useRef } from 'react';
import Page, { PageProps } from '../../components/page';
import { Box } from '@mui/material';
import DataTable, { DataTableInstance } from '../../components/data-table';
import PageHeader from '../../components/page/header';
import PageBlurb from '../../components/page/blurb';
import Text from '../../components/text';
import { DtColumn, DtFilter, DtSort } from '@/components/data-table/helpers';
import { QueryKey } from '@/lib/query-client';
import { getRootUsers } from '@/lib/services/root-user.service';
import { RootRoleLabels } from '@/lib/models/root-user.model';
import DomSize from '@/components/dom-size';

const columns: DtColumn[] = [
  { name: 'name', label: 'Name', flex: 2, sortable: true },
  { name: 'email', label: 'Email', flex: 3, sortable: true },
  { name: 'role', label: 'Role', sortable: true },
];

const RootUsersPage: FC<PageProps> = () => {
  const dtRef = useRef<DataTableInstance>(null);

  const loadData = useCallback(
    async (page: number, pageSize: number, sort?: DtSort, filter?: DtFilter) => {
      const dataset = await getRootUsers(page, pageSize, sort, filter);

      return {
        ...dataset,
        rows: dataset.rows.map(({ id, name, email, role }) => {
          return {
            id,
            name: <Box maxWidth="100%">{name}</Box>,
            email,
            role: <Text size="small">{RootRoleLabels[role]}</Text>,
          };
        }),
      };
    },
    []
  );

  return (
    <Page title="Workforce AI Security Root Users">
      <PageHeader>
        <PageBlurb>
          View a list of F5 Workforce AI Security users who have root permissions.
        </PageBlurb>
      </PageHeader>

      <DomSize>
        <DataTable
          title=""
          queryKey={QueryKey.RootUsersDataset}
          columns={columns}
          onLoad={loadData}
          ref={dtRef}
          search={true}
          sort={{ columnName: 'name', direction: 'asc' }}
        />
      </DomSize>
    </Page>
  );
};

export default RootUsersPage;
